// extracted by mini-css-extract-plugin
export default {"counter":"Counter_counter__13F98","count":"Counter_count__yLwNs","button":"Counter_button__JPZ2O"};